document.addEventListener('DOMContentLoaded', function () {
    initMainSliderSection();
    initMainSliderLabel();
    initMainSliderImageMove();
    window.addEventListener('shopify:section:load', initMainSliderSection);
    function initMainSliderSection() {
        if( document.querySelectorAll('.section-main-slider:not(.collection-slider)').length > 0 ) {
            var sliders = document.querySelectorAll('.splide:not(.splide-inited):not(.main-slider):not(.thumbnail-slider):not(.collection_splide)');
            if( sliders.length > 0 ) {
                sliders.forEach( function(slider) {
                    slider.classList.add( 'splide-inited' );
                    var sliderObj = new Splide( slider , {
                        type   : 'loop',
                        rewind: true,
                        cover: true,
                        perPage: 1,
                        perMove: 1
                    } ).mount();
                } )
            }
        }
    }
    function initMainSliderLabel() {
        if( document.querySelectorAll('.slide_label').length > 0 ) {
            const sliders = document.querySelectorAll('.slide_label');
            document.addEventListener('mousemove', function(e) {
                sliders.forEach( slider => {
                    let left = e.clientX;
                    let top = e.clientY;
    
                    let halfleft = Math.ceil( left / -40 );
                    let halftop = Math.ceil( top / -40 );
    
                    slider.style.transform = 'translate(' + halfleft + 'px' + ',' + halftop + 'px' + ')';
                } )
            });
            sliders.forEach( slider => {
                let marginLeft = slider.offsetWidth;
                let marginTop = slider.offsetHeight;
                let halfMarginLeft = Math.round(marginLeft / 2);
                let halfMarginTop = Math.round(marginTop / 2);
    
                slider.style.margin = `-${halfMarginTop}px 0 0 -${halfMarginLeft}px`;
                slider.style.height = `${marginLeft}px`;
            } )
        }
    }
    function initMainSliderImageMove() {
        if( document.querySelectorAll('.inner_slider_image').length > 0 ) {
            document.addEventListener('mousemove', function(e) {
                const sliders = document.querySelectorAll('.inner_slider_image');
                sliders.forEach( slider => {
                    let left = e.clientX;
                    let top = e.clientY;
    
                    let halfleft = Math.ceil( left / -80 );
                    let halftop = Math.ceil( top / -80 );
    
                    slider.style.transform = 'translate(' + halfleft + 'px' + ',' + halftop + 'px' + ')';
                } )
            });
        }
    }
})